import { cloneBoatDocument } from './serialize.ts';
import type { BoatDocument } from './types.ts';

export type BoatHistory = {
  past: BoatDocument[];
  future: BoatDocument[];
  limit: number;
};

export function createBoatHistory(limit = 50): BoatHistory {
  return { past: [], future: [], limit };
}

export function pushBoatUndo(history: BoatHistory, snapshotBeforeChange: BoatDocument): void {
  history.past.push(cloneBoatDocument(snapshotBeforeChange));

  if (history.past.length > history.limit) {
    history.past.shift();
  }

  history.future = [];
}

export function canUndoBoat(history: BoatHistory): boolean {
  return history.past.length > 0;
}

export function canRedoBoat(history: BoatHistory): boolean {
  return history.future.length > 0;
}

export function undoBoat(history: BoatHistory, current: BoatDocument): BoatDocument | null {
  const previous = history.past.pop();

  if (!previous) {
    return null;
  }

  history.future.push(cloneBoatDocument(current));
  return previous;
}

export function redoBoat(history: BoatHistory, current: BoatDocument): BoatDocument | null {
  const next = history.future.pop();

  if (!next) {
    return null;
  }

  history.past.push(cloneBoatDocument(current));
  return next;
}
